<div class="page">
  @if (mission) {
    <app-section-toolbar
      [sectionTitle]="'MISSION.MATERIAL' | translate"
      [isComplete]="isMaterialComplete()"
      (back)="backToMissionConfig()"
      (toggleStatus)="toggleMaterialStatus()">
    </app-section-toolbar>
  }

  <div class="columns">
    <section class="card">
      <div class="card__header">
        <div class="card__title">
          <ng-icon name="heroWrench" size="20"/>
          {{ 'MATERIAL.SKID.LABEL' | translate }}
          <span class="count-badge">{{ uniqueMissionSkids.length }}</span>
        </div>
        @if (!isMaterialComplete()) {
          <df-button size="sm" icon="heroPlus" (onClick)="openAddSkidModal()">{{ 'UI.ADD.SKID' | translate }}</df-button>
        }
      </div>
      <div class="card__body equipment-list">
        @for (missionSkid of uniqueMissionSkids; track missionSkid.skidId) {
          <article class="equipment">
            <header class="equipment__header">
              <div>
                <div class="equipment__name">{{ missionSkid.skid.skidName }}</div>
                <div class="equipment__tags">
                  @if (missionSkid.trainId) {
                    <span class="toggle-chip active">{{ missionSkid.trainId }}</span>
                  }
                  @if (missionSkid.skid.hasPump) { <span class="toggle-chip active">{{ 'MISSION_SKID.PUMP' | translate }}</span> }
                  @if (missionSkid.skid.hasFlowmeter) { <span class="toggle-chip active">{{ 'MISSION_SKID.FLOWMETER' | translate }}</span> }
                  @if (missionSkid.skid.hasGateway) { <span class="toggle-chip active">{{ 'MISSION_SKID.GATEWAY' | translate }}</span> }
                </div>
              </div>
              @if (!isMaterialComplete()) {
                <button type="button" class="icon-action danger" [title]="'DELETE' | translate" (click)="removeMissionSkid(missionSkid)">
                  <ng-icon name="heroTrash" size="18"/>
                </button>
              }
            </header>
            @if (skidProductsLabel(missionSkid.skidId)) {
              <div class="equipment__assignment">{{ skidProductsLabel(missionSkid.skidId) }}</div>
            }
            <dl class="kv-list">
              <dt>{{ 'MISSION_SKID.PUMP' | translate }}</dt><dd>{{ missionSkid.pumpName }}</dd>
              <dt>{{ 'MISSION_SKID.GATEWAY' | translate }}</dt><dd>{{ missionSkid.gatewayName }}</dd>
              <dt>{{ 'MISSION_SKID.FLOWMETER' | translate }}</dt><dd>{{ missionSkid.flowmeterName }}</dd>
              @if (missionSkid.skid.exatmregulation && missionSkid.skid.exatmregulation !== 'N/A') {
                <dt>{{ missionSkid.skid.exatmregulation }}</dt><dd>{{ missionSkid.skid.exatmclasse }}</dd>
              }
            </dl>
            <footer class="equipment__footer">
              {{ 'MATERIAL.LAST_UPDATE' | translate }} {{ missionSkid.lastUpdatedOn | timestampToDate | async }} · {{ missionSkid.lastUpdatedBy }}
            </footer>
          </article>
        } @empty {
          <div class="empty-state">
            <ng-icon name="heroWrench" size="32"/>
            <div class="empty-state__title">{{ 'UI.EMPTY.SKID' | translate }}</div>
            <div class="empty-state__text">{{ 'UI.EMPTY.SKID_TEXT' | translate }}</div>
          </div>
        }
      </div>
    </section>

    <section class="card">
      <div class="card__header">
        <div class="card__title">
          <ng-icon name="heroCpuChip" size="20"/>
          {{ 'MATERIAL.ANALYZER.LABEL' | translate }}
        </div>
        @if (!isMaterialComplete()) {
          <df-button size="sm" icon="heroPlus" (onClick)="openAnalyzerModal()">{{ 'UI.ADD.ANALYZER' | translate }}</df-button>
        }
      </div>
      <div class="card__body equipment-list">
        @for (missionAnalyzer of missionAnalyzers; track missionAnalyzer.trainpk + ':' + missionAnalyzer.analyzerId) {
          <article class="equipment">
            <header class="equipment__header">
              <div>
                <div class="equipment__name">{{ missionAnalyzer.analyzerId }}</div>
                <div class="equipment__tags">
                  <span class="toggle-chip active">{{ missionAnalyzer.trainId }}</span>
                  @if (!missionAnalyzer.analyzer.isNoAnalyzer) { <span class="toggle-chip active">{{ 'UI.ANALYZER' | translate }}</span> }
                  @if (missionAnalyzer.hasGateway) { <span class="toggle-chip active">{{ 'MISSION_SKID.GATEWAY' | translate }}</span> }
                  @if (missionAnalyzer.handleFlyingH2) { <span class="toggle-chip active">{{ 'MATERIAL.ANALYZER.FLYING_H2' | translate }}</span> }
                </div>
              </div>
              @if (!isMaterialComplete()) {
                <button type="button" class="icon-action danger" [title]="'DELETE' | translate" (click)="removeAnalyzer(missionAnalyzer)">
                  <ng-icon name="heroTrash" size="18"/>
                </button>
              }
            </header>
            <dl class="kv-list">
              @if (mission.siteWellawareId != null) {
                <dt>{{ 'MATERIAL.SITEWELLAWAREID' | translate }}</dt><dd>{{ mission.siteWellawareId }}</dd>
              }
              <dt>{{ 'MATERIAL.ANALYZER.MODEL' | translate }}</dt><dd>{{ missionAnalyzer.analyzer.analyzermodelName }}</dd>
              @if (missionAnalyzer.analyzer.exatmregulation && missionAnalyzer.analyzer.exatmregulation !== 'N/A') {
                <dt>{{ missionAnalyzer.analyzer.exatmregulation }}</dt><dd>{{ missionAnalyzer.analyzer.exatmclasse }}</dd>
              }
              <dt>{{ 'MATERIAL.TELEMETRY' | translate }}</dt><dd>{{ missionAnalyzer.analyzer.telemetrysuppliername }}</dd>
            </dl>
            <footer class="equipment__footer">
              {{ 'MATERIAL.LAST_UPDATE' | translate }} {{ missionAnalyzer.lastUpdatedOn | timestampToDate | async }} · {{ missionAnalyzer.lastUpdatedBy }}
            </footer>
          </article>
        } @empty {
          <div class="empty-state">
            <ng-icon name="heroCpuChip" size="32"/>
            <div class="empty-state__title">{{ 'UI.EMPTY.ANALYZER' | translate }}</div>
            <div class="empty-state__text">{{ 'UI.EMPTY.ANALYZER_TEXT' | translate }}</div>
          </div>
        }
      </div>
    </section>
  </div>
</div>

@if (addingSkid) {
  <app-add-skid
    [mission]="mission"
    [missionTrains]="missionTrains"
    [missionSkid]="missionSkidToUpdate"
    (closeModal)="closeAddSkidModal($event)">
  </app-add-skid>
}

@if (addingAnalyzer) {
  <app-add-analyzer
    [mission]="mission"
    [missionTrains]="missionTrains"
    (closeModal)="closeAnalyzerModal($event)">
  </app-add-analyzer>
}

@if (validatingMaterial) {
  <app-material-validation
    [mission]="mission"
    [missionSkids]="missionSkids"
    [missionAnalyzers]="missionAnalyzers"
    (closeModal)="closeMaterialValidation($event)">
  </app-material-validation>
}
